import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.match.js';
import 'core-js/modules/es.string.replace.js';

class CommentMention {
  execute(comment) {
    // find name inside double curly braces and without double curly braces
    const mentions = comment.match(/{{(.*?)}}/g) || [];
    const message = comment.replace(/{{(.*?)}}/g, '');
    const firstMention = mentions[0];
    const mention = (firstMention === null || firstMention === void 0 ? void 0 : firstMention.replace(/{{(.*?)}}/g, '$1')) || null;
    // Backend replace curly braces with html entities to prevent fake mentions
    const messageWithCurlyBraces = message.replace(/&#123;/g, '{').replace(/&#125;/g, '}');
    return {
      mention,
      message: messageWithCurlyBraces
    };
  }
}

export { CommentMention };
